import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export const ClubHederstegnChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>Ingen data tilgjengelig</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="year"
          label={{ value: 'År', position: 'insideBottom', offset: -5 }}
        />
        <YAxis
          label={{ value: 'Antall hederstegn', angle: -90, position: 'insideLeft' }}
        />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="totalDistinctions"
          stroke="#36501c"
          strokeWidth={3}
          name="Totalt"
        />
        <Line
          type="monotone"
          dataKey="plakettCount"
          stroke="#FFD700"
          strokeWidth={2}
          name="Plaketter"
        />
        <Line
          type="monotone"
          dataKey="hederstegnCount"
          stroke="#C0C0C0"
          strokeWidth={2}
          name="ANSFF/ENSFF"
        />
        <Line
          type="monotone"
          dataKey="mnsffCount"
          stroke="#90b361"
          strokeWidth={2}
          name="MNSFF+"
        />
        <Line
          type="monotone"
          dataKey="nfffCount"
          stroke="#8B4513"
          strokeWidth={2}
          name="NFFF"
        />
        <Line
          type="monotone"
          dataKey="fiapCount"
          stroke="#4169E1"
          strokeWidth={2}
          name="FIAP"
        />
        <Line
          type="monotone"
          dataKey="gpuCount"
          stroke="#9370DB"
          strokeWidth={2}
          name="GPU"
        />
        <Line
          type="monotone"
          dataKey="psaCount"
          stroke="#DC143C"
          strokeWidth={2}
          name="PSA"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
